import React from 'react';
import classNames from 'classnames';
import useLayoutColorClasses from '../../hooks/use-layout-color-classes';
import styles from './post-header-icon.scss';

type Props = {
  IconComponent: React.ComponentType<{ className?: string }>;
  className?: string;
};

export const PostHeaderIcon = ({ IconComponent, className }: Props) => {
  const { iconColorClassName } = useLayoutColorClasses();

  return (
    <div className={styles.iconWrapper} aria-hidden="true">
      <div className={classNames(styles.icon, className)}>
        <IconComponent className={classNames(iconColorClassName, className)} />
      </div>
    </div>
  );
};
